import React from "react";

/**
 * Lightweight React 19-compatible replacements for abandoned react-reveal.
 */

const baseStyle = {
  animationDuration: "0.7s",
  animationFillMode: "both",
};

function Reveal({ children, style, className, delay = 0, ...rest }) {
  // Strip react-reveal-specific props so they are not forwarded to the DOM.
  const {
    left,
    right,
    top,
    bottom,
    cascade,
    opposite,
    mirror,
    spy,
    when,
    appear,
    fraction,
    distance,
    duration,
    count,
    forever,
    wait,
    ...safeProps
  } = rest;

  return (
    <div
      className={className}
      style={{
        ...baseStyle,
        animationDelay: typeof delay === "number" ? `${delay}ms` : delay,
        ...style,
      }}
      {...safeProps}
    >
      {children}
    </div>
  );
}

export default function Fade(props) {
  return (
    <Reveal
      {...props}
      style={{
        animationName: "autobetRevealFade",
        ...(props.style || {}),
      }}
    />
  );
}
